import React from "react";
import { Box, Stack, Typography } from "@mui/material";

/** Scrollable legend for charts with many categories (pie, line, etc.). */
export default function DashboardChartLegend({ items = [], getColor, maxHeight = 96 }) {
  if (!items.length) return null;

  return (
    <Box sx={{ mt: 1, maxHeight, overflow: "auto", pr: 0.5 }}>
      <Stack direction="row" flexWrap="wrap" gap={1}>
        {items.map((it, i) => (
          <Stack
            key={`${it?.name ?? it?.key ?? "item"}-${i}`}
            direction="row"
            spacing={0.75}
            alignItems="center"
            sx={{ minWidth: 120, maxWidth: "100%" }}
          >
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                bgcolor: getColor(i, it),
                flex: "0 0 auto",
              }}
            />
            <Typography
              variant="caption"
              sx={{ lineHeight: 1.2 }}
              title={it?.name ?? it?.key ?? ""}
            >
              {it?.name ?? it?.key ?? "-"}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
